import { Delete, Edit } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import CardBox from '@src/App/Components/Cards/CardBox/CardBox';
import type Role from '@src/Objects/Role';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './RoleCard.css';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import { RoleDialog } from '@src/App/Components/Dialogs/RoleDialog/RoleDialog';
import ExpandableText from '@src/App/Components/General/ExpandableText/ExpandableText';
import FormatedTextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/FormatedTextInput/FormatedTextInput';

interface RoleCardProps {
    role: Role;
    selected?: boolean;
    onSelectChange?: (state: boolean) => void;
}

/**
 * RoleCard component.
 *
 * @param {RoleCardProps} props - The props for the RoleCard component.
 *
 * @returns {JSX.Element} The rendered RoleCard component.
 */
function RoleCard(props: RoleCardProps) {
    const { openDialog } = useDialog();
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).roles;
    const navigate = useNavigate();
    const role = props.role;
    return (
        <CardBox
            menu={
                <div>
                    <MenuItem
                        onClick={() => {
                            return openDialog(<RoleDialog id="RoleDialog" role={role} />);
                        }}
                    >
                        <ListItemIcon>
                            <Edit />
                        </ListItemIcon>
                        <ListItemText>{langStrings.edit}</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            role.delete();
                        }}
                    >
                        <ListItemIcon>
                            <Delete />
                        </ListItemIcon>
                        <ListItemText>{langStrings.delete}</ListItemText>
                    </MenuItem>
                </div>
            }
            onSelectChange={props.onSelectChange}
            selected={props.selected}
            title={role.title}
            className={'roleCard'}
            onClick={() => {
                navigate(`${role.link}`);
            }}
        >
            <ExpandableText>
                <>
                    {langStrings.description + ': '}
                    <FormatedTextInput value={role.description} readonly={true} />
                </>
            </ExpandableText>
        </CardBox>
    );
}

export default RoleCard;
